import { Box, Spinner } from '@chakra-ui/react';

// Shown while React.lazy resolves a route component.
// Minimal on purpose - reuses Chakra (already in initial bundle) and adds no extra weight.
export default function PageFallback() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minH="100vh"
      width="100%"
    >
      <Spinner size="xl" color="brand.500" thickness="4px" />
    </Box>
  );
}
